<template>
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title">{{$t('Add Tags(s)')}}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" style="height: 30px !important;width: 30px !important;
    color: #fff;" width="16" height="16" fill="currentColor" class="bi bi-x close-icon" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </span>
          </button>
        </div>
        <div class="modal-body">
        <multiselect
            ref="tagsField"
            v-model="selectedTags" 
            :options="tagsList"
            :multiple="true"
            track-by="_id"
            :custom-label="tagsLabelCallback"
            :close-on-select="true"
            :show-no-results="false"
            deselectLabel =""
            selectLabel=""
            selectedLabel=""
            :placeholder="$t('Enter tagname')"
            :hideSelected="false"
            :showNoOptions="false"
            @open="getTrendingTags()"
            @search-change="getTagsOnKeyup($event)"
            @remove="removeTags($event)"
            @select="selectTags($event)">
            <span slot="noResult">No results</span>
            <span slot="noOptions" style="display:none"></span>
            <div slot="tag" slot-scope="option" class="selected-tags-style">
            <div class="tags-display-style">{{option.option.name}}</div>
                <div class="remove-tag" v-on:click="removeSelectedTagOption(option.option)">
                    <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </div>
            </div>
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeTagsCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
            <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
            </div>
        </multiselect>
            </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="close">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-2" @click.prevent="updateTags()">{{$t('Add')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from 'vue-multiselect';
import {mapActions} from "vuex";

export default {
  props:["selectedTagsList"],
  data: () => ({
    dialog: true,
    userTypes: [],
    userTypesOptions: [],
    selectedUserIdNameMap:{},
    selectedUserIds:[],
    postData: {},
    tagsList:[],
    selectedTags:[],
    show:false,
    trendingTagsList:[]
  }),
  components:{
    "multiselect":multiselect,
  },
  methods:{
    ...mapActions("hype", ["getTagsAutocompleteFromServer"]),
    close(){
        this.$emit('close')
    },
    tagsLabelCallback(option){
        return `${option.name}`
    },
    getTagsOnKeyup(option){
      let payload = {};
          payload.params = {name:option}
      this.getTagsAutocompleteFromServer(payload).then((data) => {
        this.$nextTick(()=>{
          this.tagsList = data["tags"];
        })
      });
    },
    getTrendingTags(){
      this.getTagsAutocompleteFromServer().then((data) => {
          this.tagsList = data["tags"];
      });
    },
    updateTags(){
        this.$emit("allSelectedTags",this.selectedTags)
    },
    selectTags(option){
      let index = this.tagsList.findIndex(item => item._id == option._id);
          if(index > -1){
              this.tagsList[index].checked = true;
          }
      },
    removeSelectedTagOption(option){
      this.selectedTags = this.selectedTags.filter(e => e._id != option._id)
      this.removeTags(option)
    },
    removeTags(option){
        let index = this.tagsList.findIndex(item => item._id == option._id);
        if(index > -1){
            this.tagsList[index].checked = false;
        }
    },
    makeTagsCheckBoxSelection(option){
        if(this.selectedTags && this.selectedTags.length){
            return this.selectedTags.some((op) => op._id === option._id);
        }
    },
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.tagsField.$el.focus();             
            }, 200);
        })
      }
    }
  },
  created(){
    this.selectedTags = this.selectedTagsList;
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;



.modal-dialog {
    max-width: 450px;
    width: 450px;
    height: 100px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
     background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      user-select: text !important; 
      cursor:text;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 20%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
        font-size:$input-field-and-label-font-size;
    }
}
.close{
    background: $secondary-background-color;
    box-shadow: none !important;
    border: none;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

.all-users-selection:hover{
  background: $bg-color-on-hover;
}
.selected-tags-style{
  background: $tags-background-color;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  cursor:pointer;
  .remove-tag{
    line-height:18px;
  }
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-end: 5px;
}


.label-tree-style{
  font-size: 12px !important;
  color:$dull-text-color;
  margin-top:4px;
  word-break: break-all;
  white-space: pre-wrap;
  margin-inline-start:8px;
  line-height: 1.2;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

::v-deep{
  .multiselect {
    margin: 3px 0px;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
  }
  .multiselect__tags, .tags-style {
    background: $primary-background !important;
        border: $border-color !important;
  }
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
  }
  .multiselect__input:focus {
    outline: none;
    box-shadow: none;
  }
  .multiselect__tag-icon {
    color: $text-color !important;
    inset-inline-end: 2px !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 20px !important;
  }

  .multiselect * {
    font-size: $input-field-and-label-font-size !important;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 3px;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100%;
    min-height: 38px;
  }
  .multiselect__single {
    padding-top: 3px;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute;
    display: block;
    background: $text-color;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__element{
    height: auto;
    padding:3px;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
    height:auto;
    padding:8px;
  }

  .multiselect__select{
    display:none;
  }
  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    background: $primary-background !important;
    height: auto;
    padding: 2px 40px 2px 8px;
  }
}
.browse-icon{
    position: relative;
    inset-inline-start: 8px;
    top: 3px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}

.user-name-or-image-in-selected-option{
  border: $border-color;
height: 26px;
width: 26px;
border-radius: 5px;
text-align: center;
line-height: 26px;
text-transform: uppercase;
margin-top: -1px;
margin-inline-start: -1px;
}

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}

</style>